import { render } from "./accounting-reports.vue?vue&type=template&id=2e4daee4"
import script from "./accounting-reports.vue?vue&type=script&lang=js"
export * from "./accounting-reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__